import { Box, IconButton } from "@mui/material"
import { CommentIcon, HeartIcon, SaveIcon } from "../../../core/global/Icons"
import { MoreHoriz } from "@mui/icons-material"

export const ActionButton = ({itemData, actionHandler, setShowComment}) => {

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Check this out!',
                    text: 'Check this from philtaxes',
                    url: window.location.href,
                });
            } catch (error) {
            console.error('Error sharing:', error);
            }
        } else {
            alert('Web Share API is not supported in your browser.');
        }
    };

    return (
        <Box width="100%" display="flex" justifyContent="center"  >
            <Box 
                p="8px 24px" 
                bgcolor="#FFFFFF" 
                display="flex" 
                alignItems="center" 
                gap="16px" 
                borderRadius="100px" 
                boxShadow="rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;"
                position="absolute" 
                zIndex={1}
                bottom={30}
            >
                <Box display="flex" alignItems="center" >
                    <IconButton onClick={actionHandler}>
                        <HeartIcon height="25px" width="25px" type="default"/>
                    </IconButton>
                    <Box display={itemData.reaction === 0 ? 'none' : 'block'} pl="4" fontSize="12px">{itemData.reaction}</Box>
                </Box>
                <Box display="flex" alignItems="center" >
                    <IconButton onClick={() => setShowComment(prev => !prev)}>
                        <CommentIcon height="25px" width="24px" fill="none" stroke="#292C2F"/>
                    </IconButton>
                    <Box display={itemData.comment === 0 ? 'none' : 'block'} pl="4" fontSize="12px">{itemData.comment}</Box>
                </Box>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={actionHandler}>
                        <SaveIcon height="25px" width="24px" type="default"/>
                    </IconButton>
                    <Box display={itemData.save === 0 ? 'none' : 'block'} pl="4" fontSize="12px">{itemData.save}</Box>
                </Box>
                <IconButton onClick={handleNativeShare}>
                    <MoreHoriz/>
                </IconButton>
            </Box>
       </Box>
    )
}